/**
 * This function extracts the value of a cookie by name from the current document.
 */
export const getCookieValue = (name) => {
    if (typeof window === 'undefined') {
        return '';
    }
    const pattern = new RegExp(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    const matches = document.cookie.match(pattern);
    const [_entireMatchedString, _key, value] = matches !== null && matches !== void 0 ? matches : [];
    return value !== null && value !== void 0 ? value : '';
};
